import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isMobile } from '../_app/cuchillo/core/Basics';

class ScrollItem__BlockSections extends VScroll_Item {
    _call;
    _sliders = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!isMobile) {
            const sliders = GetBy.class('__slider', __link);
            for (let i = 0; i < sliders.length; i++) {
                const slider = new SliderScroll(sliders[i], {
                    interaction: true,
                    hasScrollbar: false,
                    itemClass: ScrollItem__SliderImages__Item
                });
                this._sliders.push(slider);
            }
        }

        this._call = () => this.loop();
        this.onShow = () => {
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
        };
    }

    resize(w, h) {
        super.resize(w, h);
        for (let i = 0; i < this._sliders.length; i++) {
            this._sliders[i].resize();
        }
    }

    loop() {
        for (let i = 0; i < this._sliders.length; i++) {
            this._sliders[i].loop();
        }
    }

    dispose() {
        for (let i = 0; i < this._sliders.length; i++) {
            this._sliders[i].dispose();
        }
        super.dispose();
    }
}

class ScrollItem__SliderImages__Item extends VScroll_Item {
    hasHiddenEnabled = false;
    info;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================

    //update () {
    /* if (this.progress > .5) {
       const p = Math.max(0, Maths.normalize(1, .5, this.progress));
       this._x = this._x + ((Metrics.WIDTH * .5) * p);
     }*/
    /* super.update();
  }

  mouseOver () { }
  mouseDown () { }
  mouseUp () { }

  show () {
    super.show();
  }

  hide () {
    super.hide();
  }*/
}

Scroll._registerClass('BlockSections', ScrollItem__BlockSections);
